// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceUsageResponse } from './SourceUsageResponse';
import {
    SourceUsageResponseFromJSON,
    SourceUsageResponseFromJSONTyped,
    SourceUsageResponseToJSON,
    SourceUsageResponseToJSONTyped,
} from './SourceUsageResponse';
import type { DailyUsageBucketResponse } from './DailyUsageBucketResponse';
import {
    DailyUsageBucketResponseFromJSON,
    DailyUsageBucketResponseFromJSONTyped,
    DailyUsageBucketResponseToJSON,
    DailyUsageBucketResponseToJSONTyped,
} from './DailyUsageBucketResponse';

/**
 * 
 * @export
 * @interface UsageAnalyticsResponse
 */
export interface UsageAnalyticsResponse {
    /**
     * 
     * @type {string}
     * @memberof UsageAnalyticsResponse
     */
    rangeFrom: string;
    /**
     * 
     * @type {string}
     * @memberof UsageAnalyticsResponse
     */
    rangeTo: string;
    /**
     * 
     * @type {string}
     * @memberof UsageAnalyticsResponse
     */
    generatedAt: string | null;
    /**
     * 
     * @type {Array<DailyUsageBucketResponse>}
     * @memberof UsageAnalyticsResponse
     */
    daily: Array<DailyUsageBucketResponse>;
    /**
     * 
     * @type {Array<SourceUsageResponse>}
     * @memberof UsageAnalyticsResponse
     */
    sources: Array<SourceUsageResponse>;
    /**
     * 
     * @type {number}
     * @memberof UsageAnalyticsResponse
     */
    totalSources: number;
    /**
     * 
     * @type {number}
     * @memberof UsageAnalyticsResponse
     */
    usedSources: number;
    /**
     * 
     * @type {number}
     * @memberof UsageAnalyticsResponse
     */
    unusedSources: number;
}

/**
 * Check if a given object implements the UsageAnalyticsResponse interface.
 */
export function instanceOfUsageAnalyticsResponse(value: object): value is UsageAnalyticsResponse {
    if (!('rangeFrom' in value) || value['rangeFrom'] === undefined) return false;
    if (!('rangeTo' in value) || value['rangeTo'] === undefined) return false;
    if (!('generatedAt' in value) || value['generatedAt'] === undefined) return false;
    if (!('daily' in value) || value['daily'] === undefined) return false;
    if (!('sources' in value) || value['sources'] === undefined) return false;
    if (!('totalSources' in value) || value['totalSources'] === undefined) return false;
    if (!('usedSources' in value) || value['usedSources'] === undefined) return false;
    if (!('unusedSources' in value) || value['unusedSources'] === undefined) return false;
    return true;
}

export function UsageAnalyticsResponseFromJSON(json: any): UsageAnalyticsResponse {
    return UsageAnalyticsResponseFromJSONTyped(json, false);
}

export function UsageAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsageAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rangeFrom': json['range_from'],
        'rangeTo': json['range_to'],
        'generatedAt': json['generated_at'],
        'daily': ((json['daily'] as Array<any>).map(DailyUsageBucketResponseFromJSON)),
        'sources': ((json['sources'] as Array<any>).map(SourceUsageResponseFromJSON)),
        'totalSources': json['total_sources'],
        'usedSources': json['used_sources'],
        'unusedSources': json['unused_sources'],
    };
}

export function UsageAnalyticsResponseToJSON(json: any): UsageAnalyticsResponse {
    return UsageAnalyticsResponseToJSONTyped(json, false);
}

export function UsageAnalyticsResponseToJSONTyped(value?: UsageAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'range_from': value['rangeFrom'],
        'range_to': value['rangeTo'],
        'generated_at': value['generatedAt'],
        'daily': ((value['daily'] as Array<any>).map(DailyUsageBucketResponseToJSON)),
        'sources': ((value['sources'] as Array<any>).map(SourceUsageResponseToJSON)),
        'total_sources': value['totalSources'],
        'used_sources': value['usedSources'],
        'unused_sources': value['unusedSources'],
    };
}

